mutation NoteTravelAuthorizationCreate(
  $input: NoteTravelAuthorizationCreateInput!
) {
  noteTravelAuthorizationCreate(input: $input) {
    note {
      id
      noteComment
      _rowTimestamp
    }
  }
}
